import _extends from 'babel-runtime/helpers/extends';
import moment from 'moment';
import { estimatedTimeUnitsBySecond } from '../utils/datetime';

var initialTask = function initialTask(params) {
  return _extends({
    completed: 0,
    description: '',
    estimatedTime: 15 * 60 * estimatedTimeUnitsBySecond,
    when: {
      date: moment().format('YYYY-MM-DD')
    },
    to: null,
    title: '',
    watchers: [],
    uploads: []
  }, params);
};

export default initialTask;
//# sourceMappingURL=task.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/models/task.js
// module id = 633
// module chunks = 0